import React, { useState,useRef } from "react";
import { AgGridReact } from "ag-grid-react";
import { AllCommunityModule, ModuleRegistry } from "ag-grid-community";
import CustomCheckboxFilter from "../../../utils/CustomCheckboxFilter";
import StatusRender from "../../../utils/StatusRenderer";
import CustomButton from "../../../utils/CustomButton";
import SearchFilter from "../../../utils/SearchFilter"; 


ModuleRegistry.registerModules([AllCommunityModule]);

const UserTable = ({ users, onEdit, onDelete }) => {
  const [quickFilterText, setQuickFilterText] = useState("");
  const gridRef = useRef(null);


   const onGridReady = (params) => {
    gridRef.current = params.api;
  };

  const handleQuickFilterChange = (e) => {
    setQuickFilterText(e.target.value);
  };
   const columnDefs = [
    {
      headerName: "Sl.No",
      valueGetter: (params) => {
        const currentPage = params.api.paginationGetCurrentPage();
        const pageSize = params.api.paginationGetPageSize();
        const rowIndex = params.node.rowIndex;
        return currentPage * pageSize + rowIndex + 1;
      },
      maxWidth: 100,
    },
    { field: "name", headerName: "Name", sortable: true, filter: CustomCheckboxFilter },
    { field: "username", headerName: "Username", sortable: true, filter: CustomCheckboxFilter },
    {
      field: "wallet_balance",
      headerName: "Wallet Balance",
      sortable: true,
    },
    {
      field: "role",
      headerName: "Role",
      sortable: true,
      filter: CustomCheckboxFilter,
      valueFormatter: (params) =>
        params.value === "Client" ? "User" : params.value,
    },
    {
        headerName: "Status",
        field: "status",
        cellRenderer: StatusRender,
      },
   {
        headerName: "Actions",
        field: "actions", 
        cellRenderer: CustomButton,
        suppressMenu: true,
        sortable: false,
        filter: false,
      },
  ];

  const defaultColDef = {
    flex: 1,
    minWidth: 100,
    resizable: true,
  };

 return (
    <div className="shadow rounded-lg">
      {/* Search Input */}
     <div className="mb-4">
        <SearchFilter value={quickFilterText} onChange={handleQuickFilterChange} />
      </div>

      {/* AG Grid Table */}
      <div className="ag-theme-alpine" style={{ height: 750, width: "100%" }}>
        <AgGridReact
          rowData={users}
          quickFilterText={quickFilterText}
          columnDefs={columnDefs}
          defaultColDef={defaultColDef}
          pagination={true}
          enableCellTextSelection={true}
          onGridReady={onGridReady}
          paginationPageSize={20}
           context={{ onEdit, onDelete }}
            overlayNoRowsTemplate="<span style='padding: 10px; display: block;'>No data found</span>"
          onFilterChanged={(params) => {
                                    const rowCount = params.api.getDisplayedRowCount();
                                    if (rowCount === 0) {
                                        params.api.showNoRowsOverlay();
                                    } else {
                                        params.api.hideOverlay();
                                    }
                                }}
        />
      </div>
    </div>
  );
};

export default UserTable;
